import React, { useEffect, useState } from "react";
import demoImg from "../assets/images/demo_cpu.png";
import plusIcon from "../assets/icons/increaseBtn.svg";
import minusIcon from "../assets/icons/decreaseBtn.svg";
import { classNames } from "../helper/classNames";

const CartItem = ({ item, updateItem, classes, edit }) => {
  const [itemCount, setItemCount] = useState(1);
  useEffect(() => {
    setItemCount(+item.count);
  }, []);
  return (
    <div className={classNames(classes, "mb-6 p-2 md:p-3 rounded-md md:rounded-lg bg-white")}>
      <div className="flex mx-2">
        {/* Image Item */}
        <div className="flex items-center">
          <img src={demoImg} alt="pcb item" className="h-[45px] min-w-[45px]" />
        </div>

        {/* Details area */}
        <div className="ml-4">
          <p className="text-dark text-base md:text-lg ">{item.part_number}</p>
          <p className="text-grey/90 text-sm mt-1 mb-3">{item.sub_category}</p>
          <div className={classNames(edit ? "flex justify-between" : "flex justify-start")}>
            {edit && (
              <div className="flex justify-between items-center">
                <p className="text-dark text-base">{itemCount}</p>
                <div className="flex flex-col space-y-1 ml-4">
                  <img
                    src={plusIcon}
                    alt="pcb increaseBtn"
                    className=""
                    onClick={() => {
                      setItemCount(itemCount + 1);
                      updateItem(
                        item.part_number,
                        itemCount + 1,
                        (+item.count + 1) * item.price,
                        () => console.log("updated")
                      );
                    }}
                  />
                  <img
                    src={minusIcon}
                    alt="pcb decrease btn"
                    className=""
                    onClick={() => {
                      if (itemCount > 1) {
                        setItemCount(itemCount - 1);
                        updateItem(
                          item.part_number,
                          itemCount - 1,
                          (+itemCount - 1) * item.price,
                          () => console.log("updated")
                        );
                      }
                    }}
                  />
                </div>
              </div>
            )}
            <p className="text-red text-base ">${item.totalPrice}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
